'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalDialogFooter = "_modal-dialog-footer_1pw0h_1";
const styles = {
	modalDialogFooter: modalDialogFooter
};

const ModalDialogFooter = ({ children }) => {
  return React__default.default.createElement("footer", { className: styles.modalDialogFooter, "data-zds": true }, children);
};

exports.ModalDialogFooter = ModalDialogFooter;
//# sourceMappingURL=Footer.cjs.js.map
